import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableFraudPreventionMessage',
  initialState: false,
  reducers: {
    setEnableFraudPreventionMessage(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableFraudPreventionMessage } = slice.actions;

export default slice.reducer;
